const getRoutes = (basePath) => ({
  companies: basePath,
  followedCompanies: `${basePath}/my_companies_follow`,
  managedCompanies: `${basePath}/my_companies_edit`,
  mostVisitedCompanies: `${basePath}/most_visited`,
  recentlyClaimedCompanies: `${basePath}/subscriptions`,
  industries: `${basePath}/industries`,
  industry: `${basePath}/industries/:industry`,
});

module.exports = {
  getRoutes,
};
